import React from "react";
import {isMobile, isMobileOnly} from "react-device-detect";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import {IconButton, Menu, MenuItem} from "@mui/material";
import {
    Directions as MapIcon,
    Email as EmailIcon,
    Link as UrlIcon,
    Phone as CallIcon,
    Sms as SmsIcon
} from "@mui/icons-material";
import {nodeUtils} from "../../utils";

const Actions = (props) => {
    const {node} = props;

    const renderButton = (title, icon, array, onClick) => {
        return (
            <PopupState variant="popover" popupId="add">
                {(popupState) => (
                    <>
                        <IconButton
                            color="primary"
                            title={title}
                            disabled={array.length === 0}
                            {...bindTrigger(popupState)}
                        >
                            {icon}
                        </IconButton>
                        <Menu {...bindMenu(popupState)}>
                            {array.map((item, index) => (
                                <MenuItem key={index} onClick={() => {
                                    popupState.close();
                                    onClick(item);
                                }}>{item.label}</MenuItem>
                            ))}
                        </Menu>
                    </>
                )}
            </PopupState>
        )
    };

    return <div className="node-actions">
        {isMobile ? renderButton("Text", <SmsIcon/>, node.phones, nodeUtils.popSms) : null}
        {isMobileOnly ? renderButton("Call", <CallIcon/>, node.phones, nodeUtils.popCall) : null}
        {renderButton("Email", <EmailIcon/>, node.emails, nodeUtils.popEmail)}
        {renderButton("Goto URL", <UrlIcon/>, node.urls, nodeUtils.openInBrowser)}
        {renderButton("Directions", <MapIcon/>, node.addresses, nodeUtils.openInGoogleMaps)}
    </div>
}

export default Actions;
